<template>
    <div class="bg-white flex flex-col justify-between p-3 w-full">
        <div class="flex-shrink font-bold text-sm">{{ titolo }}</div>
        <div class="flex items-end justify-between text-center">
            <div class="font-bold" :class="coloreStatoClass">{{ numero }}</div>
            <div class="mt-2 xs:mt-0">
<!--                <button class="px-3 py-1 text-xs border-2 border-next-dark-gray">Vedi</button>-->
                <NextButton variant="outline-secondary" component="router-link" :to="vediLink" class="block px-3 py-1 text-xs">Vedi</NextButton>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import NextButton from "@/components/NextButton.vue";

@Options({
    name:'AlertCard',
    components: {NextButton},
    props: {
        titolo: String,
        numero: [Number, String],
        coloreStatoClass: String,
        vediLink: Object,
    }
})
export default class AlertCard extends Vue {
    titolo!: string
    numero!: string|number
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
